import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GetMyPrincipal, GetRights } from 'nallian-shared-ui/lib/selectors';
import { hasIdentificationCodesAccess } from '../helpers/identificationCodes/hasIdentificationCodesAccess';

export const useCanAccessIdentificationCodes = orgId => {
  // Get rights and principalOrganisationId from the Redux store
  const rights = useSelector(GetRights);
  const myPrincipal = useSelector(GetMyPrincipal);
  const principalOrgId = myPrincipal?.organisation?.id;

  return useMemo(
    () => ({
      read: hasIdentificationCodesAccess(rights, orgId, principalOrgId, 'read'),
      create: hasIdentificationCodesAccess(rights, orgId, principalOrgId, 'create'),
      update: hasIdentificationCodesAccess(rights, orgId, principalOrgId, 'update'),
      delete: hasIdentificationCodesAccess(rights, orgId, principalOrgId, 'delete'),
    }),
    [rights, orgId, principalOrgId]
  );
};

export default useCanAccessIdentificationCodes;
